import MediaPageWrapperNavItem from './MediaPageWrapperNavItem'
import useMediaPageWrapperNav from './useMediaPageWrapperNav'
import { NavigationElement } from './MediaPageWrapperNav.types'

export default function MediaPageWrapperNav({
  activeNavElement,
}: {
  activeNavElement: NavigationElement
}): React.ReactElement {
  const navigationElements = useMediaPageWrapperNav()

  return (
    <nav className="mb-6 flex justify-center space-x-2 lg:space-x-4">
      {navigationElements.map((elem) => (
        <MediaPageWrapperNavItem href={elem.href} isActive={activeNavElement === elem.key} key={elem.key}>
          {elem.label}
        </MediaPageWrapperNavItem>
      ))}
    </nav>
  )
}
